import { Button, Form, FormProps, Input, message } from "antd";
import { SaveFilled } from "@ant-design/icons";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import {
  addCjaNotesToFolder,
  addNotesToFolder,
} from "../../redux/actions/folderActions.tsx";
import { extractErrorMessage } from "../../utils/extractErrorMessage.ts";

const { TextArea } = Input;

type FormValues = {
  notes: string;
  cja_notes: string;
};

interface NotesProps {
  isCjaNotes?: boolean;
}

export const Notes: React.FC<NotesProps> = ({ isCjaNotes }) => {
  const [notesForm] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useAppDispatch();

  const { activeFolder, loading } = useAppSelector((state) => state.folder);

  useEffect(() => {
    initializeForm();
  }, [activeFolder]);

  const initializeForm = () => {
    if (isCjaNotes)
      notesForm.setFieldsValue({
        cja_notes: activeFolder?.cja_notes || "",
      });
    else
      notesForm.setFieldsValue({
        notes: activeFolder?.notes || "",
      });
  };

  const onSaveNotes: FormProps<FormValues>["onFinish"] = async ({
    notes,
    cja_notes,
  }) => {
    try {
      if (isCjaNotes) {
        await dispatch(
          addCjaNotesToFolder({
            id: activeFolder!.id,
            cja_notes: cja_notes,
          }),
        ).unwrap();
      } else {
        await dispatch(
          addNotesToFolder({
            id: activeFolder!.id,
            notes: notes,
          }),
        ).unwrap();
      }
      messageApi.open({
        type: "success",
        content: "Notas del expediente actualizadas correctamente",
      });
    } catch (error: any) {
      messageApi.error(extractErrorMessage(error, "No se pudieron actualizar las notas."));
    }
  };

  return (
    <Form form={notesForm} onFinish={onSaveNotes}>
      {contextHolder}
      <Form.Item<FormValues> name={isCjaNotes ? "cja_notes" : "notes"}>
        <TextArea
          rows={10}
          placeholder="Notas adicionales del expediente"
          className="focus:outline-none border-gray-300 p-2"
        />
      </Form.Item>
      <Button
        icon={<SaveFilled />}
        loading={loading}
        type="primary"
        htmlType="submit"
      >
        Guardar
      </Button>
    </Form>
  );
};
